import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Grid container spacing={2} sx={{ paddingTop: '36px', paddingBottom: '36px' }}>
      <Grid item xs={12} container justifyContent="center">
        <Typography
          sx={{
            fontSize: '12px',
          }}
        >
          Copyright &copy; {`${new Date().getFullYear()}`} Plan <span style={{ color: 'red' }}>A</span> Media Group. All rights reserved.
        </Typography>
      </Grid>
    </Grid>
  )
}
